<template>
  <div class="w-full sm:w-1/1 md:w-3/5 lg:w-3/5 px-2 mb-3 flex flex-col">
    <div class="p-6 bg-[#121212] rounded-lg w-full shadow-2xl bg-base-100 lg:text-left" style="height: 100%">
      <header class="rounded-t-lg font-bold text-1xl pb-4 px-6 border-b-[1px] border-gray-500">
        <i class="uil uil-user"></i>
        Хувийн мэдээлэл
        <!--        <label class="btn btn-sm btn-outline btn-accent bg-[#0000008f] min-w-[148px]">-->
        <!--            <i class="uil uil-image-v"></i>-->
        <!--            <span class="pl-1 normal-case">Change cover</span>-->
        <!--            <input type='file' class="hidden"/>-->
        <!--        </label>-->
      </header>
      <form class="card-body w-full" :model="ruleForm" :rules="rules" ref="ruleForm">

        <!--        <div class="absolute right-0">-->
        <!--          <div class="fixed justify-end mt-[-560px] sm:mt-[-560px] md:mt-[-140px] ml-[-160px] md:ml-[-260px]">-->
        <!--            <label class="btn btn-sm btn-outline btn-accent bg-[#0000008f] min-w-[148px]">-->
        <!--              <i class="uil uil-image-v"></i>-->
        <!--              <span class="pl-1 normal-case">Change cover</span>-->
        <!--              <input type='file' class="hidden"/>-->
        <!--            </label>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="md:flex md:items-center mb-6 pt-6">
          <div class="md:w-1/3">
            <label class="block md:text-right mb-1 md:mb-0 pr-4">
              <span class="label-text">Зураг:</span>
            </label>
          </div>

          <div class="md:w-2/3">
            <div style="width: 90%">
              <div style="display: flex; flex-direction: row; gap:40px; align-items: center">
                <div class="avatar justify-center" v-if="ruleForm.avatar">
                  <div class="rounded-full w-25 h-25">
                    <img :src="config.HOST +ruleForm.avatar" class="rounded-full" style="object-fit: cover; width: 100%; height: 100%;">
                  </div>
                </div>
                <FileUpload
                    mode="basic" name="file" url="https://btvplus.mn/lambda/krud/upload"
                    :chooseLabel="ruleForm.avatar ==null?'Зураг сонгох':'Зураг солих'"
                    accept="image/*" :maxFileSize="2000000" :auto="true"
                    @upload="upload($event)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="md:flex md:items-center mb-6">
          <div class="md:w-1/3">
            <label class="block md:text-right mb-1 md:mb-0 pr-4">
              <span class="label-text">Нэр:</span>
            </label>
          </div>
          <div class="md:w-2/3">
            <input type="text" placeholder="Таны нэр"
                   class="input input-bordered hover:border-accent w-full md:w-3/4 email-form"
                   v-model="ruleForm.firstname">
          </div>
        </div>
        <div class="md:flex md:items-center mb-6">
          <div class="md:w-1/3">
            <label class="block md:text-right mb-1 md:mb-0 pr-4">
              <span class="label-text">Овог:</span>
            </label>
          </div>
          <div class="md:w-2/3">
            <input type="text" placeholder="Таны овог"
                   class="input input-bordered hover:border-accent w-full md:w-3/4 email-form"
                   v-model="ruleForm.lastname">
          </div>
        </div>
        <div class="md:flex md:items-center mb-6">
          <div class="md:w-1/3">
            <label class="block md:text-right mb-1 md:mb-0 pr-4">
              <span class="label-text">И-мэйл:</span>
            </label>
          </div>
          <div class="md:w-2/3">
            <input type="text" placeholder="И-мэйл хаяг"
                   class="input input-bordered hover:border-accent w-full md:w-3/4 email-form" v-model="ruleForm.email">
          </div>
        </div>
        <div class="md:flex md:items-center mb-6">
          <div class="md:w-1/3">
            <label class="block md:text-right mb-1 md:mb-0 pr-4">
              <span class="label-text">Утас:</span>
            </label>
          </div>
          <div class="md:w-2/3">
            <input type="text" placeholder="Утасны дугаар"
                   class="input input-bordered hover:border-accent w-full md:w-3/4 email-form" v-model="ruleForm.phone">
          </div>
        </div>
        <!--        <div class="md:flex md:items-center mb-6">-->
        <!--          <div class="md:w-1/3">-->
        <!--            <label class="block md:text-right mb-1 md:mb-0 pr-4">-->
        <!--              <span class="label-text">Хүйс:</span>-->
        <!--            </label>-->
        <!--          </div>-->
        <!--          <div class="md:w-2/3">-->
        <!--            <div class="w-1/2 flex gap-4 w-full md:w-3/4">-->
        <!--              <label class="cursor-pointer label basis-1/2">-->
        <!--                <input type="radio" name="gender" checked="checked"-->
        <!--                       class="radio radio-accent radio-xs" value="" v-model="ruleForm.gender">-->
        <!--                <span class="label-text pl-2">Эрэгтэй</span>-->
        <!--              </label>-->
        <!--              <label class="cursor-pointer label basis-1/2">-->
        <!--                <input type="radio" name="gender" class="radio radio-accent radio-xs"-->
        <!--                       value="" v-model="ruleForm.gender">-->
        <!--                <span class="label-text pl-2">Эмэгтэй</span>-->
        <!--              </label>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="md:flex md:items-center">
          <div class="md:w-2/3"></div>
          <div class="w-full">
            <Button :loading="isLoading" class="mt-5 bg-[#2e2d2d] hover:bg-[#9697a3]" @click="submitForm">
              <div class="text-center w-full">Хадгалах</div>
            </Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import config from "@store/_boot/config";
import FileUpload from 'primevue/fileupload';

export default {
  name: 'ProfileForm',
  components: {
    FileUpload: FileUpload
  },
  data() {
    return {
      config: config,
      ruleForm: {
        userId: '',
        coverImage: '',
        avatar: null,
        firstname: '',
        lastname: '',
        nickename: '',
        phone: '',
        gender: '',

      },
      form: {
        name: "",
        fileUploaded: false, // optional
      },
      idImageEdit: false,
      // selectedFile:nu
      isLoading: false,
      rules: {
        firstname: [
          {required: true, message: "Нэрээ оруулна уу!", trigger: "blur"},
          {min: 3, max: 50, message: "Нэр 3-50 тэмдэгт орсон байх ёстой.", trigger: "blur"},
        ],
        lastname: [
          {required: true, message: "Овгоо оруулна уу!", trigger: "blur"},
          {min: 3, max: 50, message: "Овог 3-50 тэмдэгт орсон байх ёстой.", trigger: "blur"},
        ],
        email: [
          {required: true, message: "И-мэйл хаяг оруулна уу!", trigger: "blur"},
          {type: "email", message: "Зөв и-мэйл оруулна уу!", trigger: "blur"},
        ],
        phone: [
          {required: true, message: "Утасны дугаар оруулна уу!", trigger: "blur"},
          {min: 8, max: 12, message: "Утасны дугаар 8-12 тэмдэгт орсон байх ёстой.", trigger: "blur"},
        ],
      },
      // gender: [
      //   {required: true, message: 'Хүйсээ сонгоно уу!', trigger: 'change'}
      // ]
    };
  },

  computed: {
    ...mapGetters(['isLoadingAuth', 'user']),
  },

  created() {
    this.ruleForm.userId = this.user.id;
    this.ruleForm.avatar = this.user.avatar;
    this.ruleForm.firstname = this.user.first_name;
    this.ruleForm.lastname = this.user.last_name;
    this.ruleForm.email = this.user.email;
    // this.ruleForm.gender = this.user.gender;
    this.ruleForm.phone = this.user.phone;
  },

  methods: {
    ...mapActions(['saveUserInfo']),

    upload(event) {
      this.idImageEdit = true;
      this.ruleForm.avatar = event.xhr.responseText;
    },

    submitForm() {
      // this.$refs.ruleForm.validate((valid) => {
      //   if (valid) {
      this.saveUserInfo(({vm: this}))
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
  },
};
</script>
<style>
.email-form {
  color: #9697a3;
  height: 44px;
  width: 90%;
  padding: 10px;
  border-radius: 5px;
  outline-color: #e67e22;
  background-color: rgba(35, 45, 64, 0.5);
}
</style>
